var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkImg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.84,
    height: 176.881,
    viewBox: "0 0 120.84 176.881",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354",
    transform: "translate(33.788 47.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M78.458-54.686a38.416,38.416,0,0,0,5.859-14.169c.858-5.444-.847-12.651-3.974-16.774A22.891,22.891,0,0,0,63.48-94.146c-7.628-.352-12.89.676-17.066,3.34A17.223,17.223,0,0,0,38.839-79.3c-.069.373-.122.714-.176,1.028-.112.645-.2,1.151-.32,1.582a6.034,6.034,0,0,0,.08,4.853c.511,1.167.154,2.472-1.151,4.224l-.453.6c-1.939,2.583-3.2,4.4-2.972,5.992.261,1.976,2.141,2.589,2.94,2.85l.037.011.192.064c.069.032.139.053.213.08a5.321,5.321,0,0,1-.32.852l-.075.16a3.053,3.053,0,0,0,.149,3.4,2.521,2.521,0,0,0-.186,1.124v.069a2.586,2.586,0,0,0,.762,1.763c.32.383.384.463.282.895-.724,2.967-.08,4.576.368,5.268a3.068,3.068,0,0,0,2.051,1.374,18.923,18.923,0,0,0,5.8.128h.016a18.3,18.3,0,0,1,2.04-.128,1.951,1.951,0,0,1,1.7.932,15.217,15.217,0,0,1,.607,5.891,6.821,6.821,0,0,1-.874,2.876l-.65.879a.584.584,0,0,0,.122.826.581.581,0,0,0,.352.117.581.581,0,0,0,.474-.24l.714-.959.021-.048A7.927,7.927,0,0,0,51.6-36.144a16.523,16.523,0,0,0-.66-6.4,3.05,3.05,0,0,0-2.812-1.747,20.1,20.1,0,0,0-2.168.128l-.016.005a17.909,17.909,0,0,1-5.465-.117,1.893,1.893,0,0,1-1.278-.852c-.852-1.321-.373-3.659-.208-4.347a1.89,1.89,0,0,0-.527-1.928,1.5,1.5,0,0,1-.479-.98.9.9,0,0,0-.005-.123v-.021a1.214,1.214,0,0,1,.208-.81l.3-.415-.368-.357a1.82,1.82,0,0,1-.218-2.392l.08-.17c.447-.985.586-1.7.389-2.056l-.075-.133-.128-.085a1.817,1.817,0,0,0-.458-.165c-.091-.027-.186-.059-.261-.085s-.165-.059-.266-.091l-.032-.011c-.953-.314-1.982-.74-2.136-1.886s1.039-2.844,2.749-5.119l.453-.6c1.593-2.136,1.987-3.8,1.289-5.407a4.9,4.9,0,0,1-.032-4.048,14.723,14.723,0,0,0,.352-1.72c.053-.3.107-.639.176-1A16.059,16.059,0,0,1,47.053-89.81c3.952-2.525,9-3.494,16.369-3.153A21.677,21.677,0,0,1,79.4-84.909c2.951,3.888,4.56,10.712,3.745,15.868A36.978,36.978,0,0,1,77.51-55.395c-1.886,2.546-2.764,4.384-2.844,5.96-.245,4.863.815,9.529,3.793,16.651l.021.048.559.874a.6.6,0,0,0,.82.176.6.6,0,0,0,.176-.82l-.5-.783c-2.887-6.914-3.92-11.426-3.686-16.086C75.918-50.707,76.722-52.342,78.458-54.686Z",
    transform: "translate(-33.822 94.213)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M68.078-75.9c0-5.412-1.609-9.9-4.65-12.981a15.367,15.367,0,0,0-11.239-4.389,15.367,15.367,0,0,0-11.239,4.389C37.9-85.8,36.294-81.31,36.294-75.9a23.211,23.211,0,0,0,5.263,14.643,16.815,16.815,0,0,0,8.2,5.79l-1.683,3.409H51.6v23.64a.59.59,0,0,0,.591.591.593.593,0,0,0,.591-.591v-23.64H56.3L54.623-55.47C61.18-57.281,68.078-65.953,68.078-75.9ZM54.4-53.238H49.978l.969-1.982a8.217,8.217,0,0,0,1.241.1,8.1,8.1,0,0,0,1.236-.1Zm-2.211-3.074c-3.169,0-6.8-2.125-9.716-5.689a22.054,22.054,0,0,1-4.991-13.9c0-5.092,1.491-9.295,4.309-12.15a14.233,14.233,0,0,1,10.4-4.032,14.233,14.233,0,0,1,10.4,4.032C65.4-85.193,66.9-80.99,66.9-75.9a21.963,21.963,0,0,1-5.05,13.892C58.959-58.49,55.257-56.312,52.189-56.312Z",
    transform: "translate(-23.128 98.299)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.18
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M148.319-66.873V-32.1c0,40.706-23.373,60.383-41.468,75.58-7.484,6.3-14.041,11.8-17.4,17.636a1.726,1.726,0,0,1-.666.693,1.615,1.615,0,0,1-2.173-.6c-3.393-5.833-9.987-11.335-17.5-17.631C50.948,28.356,27.479,8.68,27.479-32.1V-66.873a1.609,1.609,0,0,1,1.577-1.614c38.7,0,57.293-33.329,57.554-33.787a1.67,1.67,0,0,1,.6-.591,1.6,1.6,0,0,1,2.173.591c.037.1,18.654,33.787,57.352,33.787A1.614,1.614,0,0,1,148.319-66.873Zm-3.2,34.778V-65.323c-33.387-.762-52.11-25.483-57.123-33.126-5.007,7.644-23.767,32.365-57.32,33.126V-32.1c0,39.321,22.809,58.438,40.477,73.241,6.855,5.737,12.954,10.877,16.843,16.347,3.825-5.5,9.955-10.643,16.816-16.449C122.41,26.279,145.118,7.162,145.118-32.1Z",
    transform: "translate(-27.479 103.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M50.322-71.264a1.616,1.616,0,0,1,1.614,1.614,1.61,1.61,0,0,1-1.614,1.582H42.049A1.615,1.615,0,0,1,40.43-69.65a1.621,1.621,0,0,1,1.619-1.614Z",
    transform: "translate(28.555 240.699)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M58.523-68.852a1.567,1.567,0,0,1-1.587,1.582H39.2a1.582,1.582,0,0,1-1.582-1.582A1.61,1.61,0,0,1,39.2-70.466H56.935A1.594,1.594,0,0,1,58.523-68.852Z",
    transform: "translate(16.402 244.151)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkImg7);
export default __webpack_public_path__ + "static/media/work-img7.8311b4c64c2287373ffc3d4ad3c3e1b1.svg";
export { ForwardRef as ReactComponent };